import React from 'react';

const Link = ({args, key}) => {
  const style = require('./Link.scss');
  const text = args.shift();
  const url = args.shift();
  var settings = {
    href: url,
    target: "_blank",
    cssClass: "default"
  };
  while(args.length) {
    const arg = args.shift().split(":").map(arg => arg.trim());
    if(arg.length === 1) {
      settings.cssClass = arg[0];
    } else {
      settings[arg[0]] = arg[1];
    }
  }
  return (<a key={key} className={style[settings.cssClass]} {...settings}>{text}</a>);
};


export default Link;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/StyledText/StyledTextComponents/Link.js
 **/